export default __webpack_public_path__ + "static/media/home-background.ab35dcec.jpg";